<template>
  <div class="auto-save">
    <p class="save-tip" v-if="showTip">{{ tipText }}</p>
    <p class="save-tip tip2" v-if="showDialog">
      发现存在草稿，是否载入？
      <a href="javascript:;" @click="updateForm()">载入草稿</a>
      <a href="javascript:;" @click="cancelForm()">放弃草稿</a>
    </p>
    <p class="save-tip" v-if="showSave">
      <a href="javascript:;" @click="saveFromData()">点击保存表单草稿</a>
    </p>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  export default {
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    props: ['form', 'saveName'],
    data() {
      return {
        name: '',
        showTip: false,
        showDialog: true,
        showSave: false,
        tipText: '',
        tipText1: '正在自动保存表单内容...',
        tipText2: '保存成功',
        historyFormData: '',
        saveIntervalTime: 20000,
      }
    },
    created() {
      this.name = this.saveName + '_' + this.userData.id
    },
    mounted() {
      this.showDialog = false
      // 第一次进入时尝试获取草稿
      this.getFromData()
      // 自动保存
      setInterval(() => {
        if (!this.historyFormData) {
          this.saveFromData()
        }
      }, this.saveIntervalTime);
    },
    methods: {
      cancelForm() {
        this.historyFormData = ''
        this.showDialog = false
        // 删除草稿
        this.saveFromData('cancel')
      },
      // 载入草稿
      updateForm() {
        this.$emit('updateForm', this.historyFormData)
        this.showDialog = false
        this.historyFormData = ''
      },
      // 保存草稿
      saveFromData(type) {
        this.$emit('getFormData')
        this.historyFormData = ''
        this.showSave = this.showDialog = false
        this.showTip = true
        this.tipText = this.tipText1

        ajax.post('/common/form/draft/save', {
          name: this.name,
          content: type != 'cancel' ? JSON.stringify(this.form) : ''
        }, (res) => {
          this.tipText = this.tipText1
          setTimeout(() => {
            this.showSave = true
            this.showTip = false
          }, 1500)
        })
      },
      // 获取草稿
      getFromData() {
        ajax.get('/common/form/draft/detail', {
          name: this.name
        }, (res) => {
          console.log(res)
          if (res.vo && res.vo.content) {
            // 如果有草稿
            this.historyFormData = JSON.parse(res.vo.content)
            this.showDialog = true
            this.showSave = false
            setTimeout(() => {
              this.showSave = true
            }, 2000)
          } else {
            //...
            this.showDialog = false
            this.showSave = true
          }
        })
      }
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/AutoSave.vue